import React, { Component } from 'react'
import { connect } from "react-redux";
import Grid from "../../../../../components/grid";
import { getBillingServices, UpdateBillingServices, editClientData } from "../../../../../store/actions";
import RadiosRenderer from "../../../../../components/grid/RadiosRenderer";
import { sortBy } from 'lodash';

class AnnualBillingView extends Component {
  state = {
    loading: false,
    isSelectedRowData: "",
    isShow: false,
    isAddOrderShow: false,
    checked: false,
    isSelectedRowData: [],
    annualBilling: "",
    columnDefs: [

      {
        headerName: "Service Name",
        field: "serviceName",
        width: 110,
        flex: 1,

      },
      {
        headerName: "Description",
        field: "description",
        resizable: true,
        width: 150,
        flex: 1,

      },
      {
        headerName: "Created At",
        field: "createdAt",
        resizable: true,
        width: 150,
        flex: 1,
        valueFormatter: params => new Date(params.value).toLocaleString()
      },
      {
        headerName: "Billable",
        field: "isBillable",
        resizable: true,
        width: 150,
        flex: 1,
        cellRenderer: RadiosRenderer,
        cellRendererParams: {
          onChanged: (params) => this.onClickAnnualBilling(params),
          radioValues: [{ val: "billable", label: "Billable" }, { val: "excluded", label: "Excluded" }],
          nameProp: "systemId"
        },
      },

    ],
    rowData: [],
  };
  searchText = '';

  annualBilling = [];

  async componentDidMount() {
    await this.props.getBillingServices();
    this.setState({ rowData: this.setRowData() });
  };

  setRowData = () => {
    let searchFilter = this.searchText.toLowerCase();
    let rowData = this.props.BillingServicesReducer;
    if (rowData?.length) {
      rowData = rowData.filter(service => service.serviceName.toLowerCase().includes(searchFilter));
    };
    return sortBy(rowData, "serviceName");
  };

  searchInput = (e) => {
    this.searchText = e.target.value;
    this.setState({ rowData: this.setRowData() });

  }/* 
  refreshGrid = () => {
    this.gridApi.refreshServerSide();
  } */

  saveServices = async () => {

    let eventData = this.state.annualBilling
    let payload = {
      billingServices: eventData
    }
    await this.props.UpdateBillingServices(payload);
  };

  onClickAnnualBilling(data) {
    let findIndex = this.annualBilling.findIndex(res => res.systemId === data.systemId);
    if (findIndex === -1) {
      this.annualBilling.push(data)
    } else {
      this.annualBilling[findIndex] = data;
    }
    this.setState({ annualBilling: this.annualBilling })
  }



  render() {
    return (

      <>
        <div className="shadow_white_box full-box mt-0">
          <div className="filter-list d-flex align-items-center justify-content-between">
            <div className="filter-field d-flex">
              <input type="text" placeholder="Search" autoComplete="off" onChange={(e) => this.searchInput(e)} />
            </div>
            <div className="filter-field d-flex">
              <button className="mla fs12 primary mini" onClick={this.saveServices}>Save</button>
            </div>

          </div>
          <div className="clients_grid">
            <Grid
              columnDefs={this.state.columnDefs}
              modules={this.state.modules}
              rowData={this.state.rowData}
              height='600px'
            >

            </Grid>
          </div>

        </div>

      </>
    )
  }
}


const mapStateToProps = ({ BillingServicesReducer, ClientDataReducer }) => ({ BillingServicesReducer, ClientDataReducer });
export default connect(mapStateToProps, { getBillingServices, editClientData, UpdateBillingServices })(AnnualBillingView);
